import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddPlaylistIcon = ({
  size = '100',
  padding = '100'
}) => {
  const label = I18n.text('learningCenter.savedItems.playlistDetails.addToPlaylist');
  return /*#__PURE__*/_jsx(Tooltip, {
    title: label,
    children: /*#__PURE__*/_jsx(IconCircle, {
      "aria-label": label,
      backgroundColor: "fill-accent-neutral-default",
      borderWidth: "0",
      color: "fill-surface-default",
      icon: AddIcon,
      padding: padding,
      size: size
    })
  });
};
export const RemovePlaylistIcon = ({
  size = '100',
  padding = '100'
}) => {
  const label = I18n.text('learningCenter.savedItems.playlistDetails.removeFromPlaylist');
  return /*#__PURE__*/_jsx(Tooltip, {
    title: label,
    children: /*#__PURE__*/_jsx(IconCircle, {
      "aria-label": label,
      backgroundColor: "fill-accent-teal-default",
      borderWidth: "0",
      color: "fill-surface-default",
      icon: SuccessIcon,
      padding: padding,
      size: size
    })
  });
};